import RouteNames from '../../../../../../app/router/_internals/RouteNames.enum';
export default Object.freeze({
	GENERAL: `${RouteNames.RESOURCES}-general`,
	NUMBERS: `${RouteNames.RESOURCES}-numbers`,
	FAILURE: `${RouteNames.RESOURCES}-failure`,
	PERMISSIONS: `${RouteNames.RESOURCES}-permissions`,
});
